import { ApiHeaders, FetchOptions } from '../types'

export class ApiError extends Error {
  status: number

  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

class ApiClient {
  private BASE_URL: string

  private headers: ApiHeaders = {
    'Content-Type': 'application/json',
  }

  constructor(baseUrl: string) {
    this.BASE_URL = baseUrl
  }

  public async request<T>(path: string, options: FetchOptions): Promise<T> {
    const response = await fetch(`${this.BASE_URL}${path}`, {
      method: options.method,
      body: options.body ? JSON.stringify(options.body) : undefined,
      headers: {
        // Fastify rejects an empty body when Content-Type is application/json
        // (FST_ERR_CTP_EMPTY_JSON_BODY) — only declare it when a body is sent.
        ...(options.body ? this.headers : {}),
        ...options.headers,
      },
    })

    if (!response.ok) {
      let message = 'Something went wrong'
      try {
        const errorResponse = await response.json()
        message = errorResponse?.message || message
      } catch {
        // no JSON body — keep the generic message
      }
      throw new ApiError(response.status, message)
    }

    if (response.status === 204) {
      return undefined as T
    }

    const json = await response.json()

    return json as T
  }
}

export default ApiClient
